// extracted by mini-css-extract-plugin
export default {"root":"_dVgttzNmsunhuDBCOFw","sector":"a3NXYiV_1p2Ca2089uMG","sectorHeader":"VejP62eaRs1nX5kA_HiZ","sectorEnter":"O1fgdHp1NTuqdMNE1kl7"};